














import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ConfirmModal from "@/components/modal/Confirm.vue";
import UserForm from "./Form.vue";
import { UserDto } from "@/store/users/user.interface";
import User from "@/store/users";

@Component({
  components: {
    "user-form": UserForm
  }
})
export default class AppUserView extends Vue {
  isLoading: boolean = false;
  error: any = "";
  data: any = null;
  temp: any = null;
  id: number = 0;
  disabled: boolean = true;

  async created() {
    this.id = parseInt(this.$route.params.id);
    const res = await User.findOne(this.id);
    this.data = JSON.parse(JSON.stringify(res.response.data));
    this.temp = JSON.parse(JSON.stringify(res.response.data));
  }

  onEditable() {
    this.disabled = !this.disabled;
  }

  async onSubmit(form: any) {
    this.error = "";
    this.isLoading = true;
    try {
      await User.updateOne(this.id, form);

      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("Saved");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
      this.$toasted.error(this.error);
    }
  }

  async onConfirmRemove() {
    this.isLoading = true;
    try {
      await User.removeOne(this.id);
      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("Removed");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.message;
      this.$toasted.error(this.error);
    }
  }

  async onRemove() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }

  async onCancel() {
    this.data = JSON.parse(JSON.stringify(this.temp));
    this.disabled = true;
  }
}
